import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import 'draft-js/dist/Draft.css';

import { Box, Typography } from '@mui/material';

import { apiList } from '../../../api/callAPI';

import useUser from '../../../hook/useUser';
import useGlobalStatus from '../../../hook/useGlobalStatus';

import * as urlConstants from '../../../constants/url';
import * as alertConstants from '../../../constants/alertMsg';

import { MODAL_CREATE_REPORT } from '../../modal/constants';

import { handleColorSystem } from '../../customComponent/colorSystem';
import theme from '../../../theme';


const media = 'LINE';
const initCustomFieldsIndexNumber = 100;

const getSelectedCustomFields = (allCustomData, saveCustomData) => {
  const allFields = allCustomData.map((edition) => {
    const formatExpression = edition.id.replace(/\s+/g, '');
    return {
      name: `${edition.name}(自訂欄)`,
      expression: `${formatExpression}_custom`,
      format: 'DEFAULT',
      type: 'CUSTOM',
      sheet: [],
      cidname: edition.cidname,
      cid: edition.cid,
      indexNumber: edition.indexNumber
    };
  })

  const formatSaveCustomData = saveCustomData.map((edition) => {
    const formatExpression = edition.expression.replace(/\s+/g, '');
    return {
      ...edition,
      expression: formatExpression,
    }
  })

  const newFields = _.differenceBy(allFields, formatSaveCustomData, 'expression'); // allFields 有、formatSaveCustomData 沒有的新欄位
  const newAndSaveFields = _.concat(newFields, formatSaveCustomData); // 新欄位 + 儲存的欄位
  const matchFields = _.intersectionBy(newAndSaveFields, allFields, 'expression'); // 篩選掉已被移除的儲存欄位
  const updateFieldsIndex = matchFields.map((edition, index) => {
    return {
      ...edition,
      indexNumber: edition.indexNumber != null ? edition.indexNumber : initCustomFieldsIndexNumber + index
    }
  })
  return updateFieldsIndex;
}

const LineFieldsCustomConvertions = (props) => {
  const {
    selectedAdAccounts,
    campaignGoalsList,
    currentSheetName,
    setCurrentSheetName,
    setSelectedExcelIndex,
    setCurrentSheetSelectFields,
    setOrigiCustomData,
    selectedCustomFields,
    setSelectedCustomFields,
    setCurrenOptionFields,
    customFieldsData,
    setModalName,
    scrollToAnchor,
    setIsLoading
  } = props;

  const history = useHistory();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { currentActiveData, setCurrentActiveData, entryPath, setModalContent, setIsModalOpen } = useGlobalStatus();
  const { colorSystem, mainColor, lightColor, darkColor, w01Color } = handleColorSystem('LINE');

  //改變帳號時清空自訂欄
  useEffect(() => {
    setOrigiCustomData([]);
    setSelectedCustomFields([]);

    if (entryPath === urlConstants.PAGE_LINE_EDIT_DATA) {
      const filterCustomFields = currentActiveData.fields.filter((el) => el.cid !== null);

      //若設定過自訂欄，進入編輯頁會自動更新自訂欄
      if (selectedAdAccounts.length !== 0 && filterCustomFields.length !== 0) {
        fetchCustomData('auto');
      }
    }
  }, [selectedAdAccounts])

  const handleGetCustomFields = () => {
    if (selectedCustomFields.length > 0) return;
    setCurrentSheetName("");
    setSelectedExcelIndex(null);
    setOrigiCustomData([]);
    setSelectedCustomFields([]);
    setCurrentSheetSelectFields([]);
    setCurrenOptionFields(null);
    fetchCustomData('click');
  }

  const fetchCustomData = (type) => {
    setIsLoading(true);
    const adAccountId = selectedAdAccounts.map(el => el.adAccountId);

    apiList.lineCustomFields({
      cid: adAccountId.toString()
    })
      .then(res => {
        if (res.status === 200) {
          const resData = _.unionBy(res.data.result, 'id');
          const isEmptyData = resData === null || !resData.length;

          if (entryPath.includes('create')) {
            handleCreateCustom(resData, isEmptyData);
          } else if (entryPath.includes('edit')) {
            handleEditCustom(resData, isEmptyData, type);
          }

          setIsLoading(false);

        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          alert(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })
  }

  const handleCreateCustom = (resData, isEmptyData) => {
    setOrigiCustomData(isEmptyData ? [] : resData);
    setSelectedCustomFields(isEmptyData ? [] : customFieldsData);
    setModalContent(isEmptyData ? { ...MODAL_CREATE_REPORT['checkNoCustomfields'], media: media } : { ...MODAL_CREATE_REPORT['checkImportCustomfields'], media: media });
    setIsModalOpen(true);
  }

  const handleEditCustom = (resData, isEmptyData, type) => {
    const filterCustomFields = currentActiveData.fields.filter((el) => el.cid !== null);

    setOrigiCustomData(isEmptyData ? [] : resData);
    setSelectedCustomFields(isEmptyData ? [] : getSelectedCustomFields(resData, filterCustomFields));

    if (type === 'click') {
      setModalContent(isEmptyData ? { ...MODAL_CREATE_REPORT['checkNoCustomfields'], media: media } : { ...MODAL_CREATE_REPORT['checkImportCustomfields'], media: media });
      setIsModalOpen(true);
    }
  }

  return (
    <Box
      sx={{
        background: `${theme.palette.grey.w100}`,
        borderBottom: `1px solid ${theme.palette.grey.w200}`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ padding: '16px 0px 12px 16px' }}>
          {currentSheetName !== "" ? <Typography>{currentSheetName}</Typography> :
            <Typography sx={{ p: '12px 0' }}></Typography>
          }
        </Box>

        <Box>
          {
            selectedAdAccounts.length > 0 &&
            campaignGoalsList.length !== 0 &&
            <Typography
              sx={{
                cursor: 'pointer',
                pr: '20px',
                color: selectedCustomFields.length ? theme.palette.grey.w400 : mainColor
              }}
              onClick={() => handleGetCustomFields()}
            >匯入自訂欄
            </Typography>
          }
        </Box>

      </Box>
    </Box>
  )
}

export default LineFieldsCustomConvertions;